/* "🔥 N people viewed in the last 24 hours" on the first product image
   (snippets/product-view-count.liquid). Counts live in the SIAMKICK
   Customizer app: POST adds a view and returns the totals, GET only returns
   them. The badge shows the total named by its data-metric: "count" (people,
   last 24 hours, the default) or "views7d" (page views, last 7 days).

   Every product-page view counts as a page view once the shopper allows
   analytics under the store's cookie banner (where no banner is required,
   Shopify reports analytics as allowed); the first per product per browser
   per day also counts as a person. Quick add and bots only ever read. The
   count shown is the real one.

   Lives in an external file (not inline) because the storefront's
   instant-loader app swaps page content into the DOM, and inline scripts
   injected that way never execute. A MutationObserver picks up badges the
   loader, or quick add, swaps in. */
(function () {
	if (window.SKViewCount) return;
	window.SKViewCount = true;

	var DAY_MS = 24 * 60 * 60 * 1000;
	var BOT = /bot|crawl|spider|slurp|headless|lighthouse|prerender/i;
	var isBot = Boolean(navigator.webdriver) || BOT.test(navigator.userAgent || '');

	function storageKey(productId) { return 'sk-viewed:' + productId; }

	function countedToday(productId) {
		try {
			var at = Number(localStorage.getItem(storageKey(productId)));
			return Boolean(at) && Date.now() - at < DAY_MS;
		} catch (error) {
			return false;
		}
	}

	function markCounted(productId) {
		try { localStorage.setItem(storageKey(productId), String(Date.now())); } catch (error) {}
	}

	function unmarkCounted(productId) {
		try { localStorage.removeItem(storageKey(productId)); } catch (error) {}
	}

	/* Chrome can load a page the shopper hasn't opened yet (address-bar
	   predictions, speculation rules), and that page runs its scripts, so
	   nothing is counted until the page is actually shown. */
	function whenShown(callback) {
		if (document.prerendering) {
			document.addEventListener('prerenderingchange', callback, { once: true });
		} else {
			callback();
		}
	}

	/* Resolves true only when Shopify's Customer Privacy API says analytics
	   is allowed; an API that fails to load counts as "not allowed". */
	var analyticsCheck = null;
	function analyticsAllowed() {
		if (analyticsCheck) return analyticsCheck;
		analyticsCheck = new Promise(function (resolve) {
			function ask() {
				try {
					resolve(window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true);
				} catch (error) {
					resolve(false);
				}
			}
			if (window.Shopify && window.Shopify.customerPrivacy) return ask();
			if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
				window.Shopify.loadFeatures(
					[{ name: 'consent-tracking-api', version: '0.1' }],
					function (error) { if (error) resolve(false); else ask(); }
				);
				return;
			}
			resolve(false);
		});
		return analyticsCheck;
	}

	function request(badge, method, newPerson) {
		var url = badge.dataset.endpoint + '?product_id=' + encodeURIComponent(badge.dataset.productId);
		if (method === 'POST') url += '&new_person=' + (newPerson ? '1' : '0');
		return fetch(url, {
			method: method,
			headers: { Accept: 'application/json' },
			credentials: 'same-origin',
			keepalive: method === 'POST'
		})
			.then(function (response) { return response.ok ? response.json() : null; })
			.then(function (data) {
				var count = data ? Number(data[badge.dataset.metric || 'count']) : NaN;
				return Number.isFinite(count) ? count : null;
			})
			.catch(function () { return null; });
	}

	function formatCount(count) {
		return new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 })
			.format(count)
			.toLowerCase();
	}

	/* Showing: the badge sits on the first image only, so it hides while
	   another slide is active. */
	function show(badge, count) {
		// Test-theme preview only: ?sk_preview_views=N stands in for N real views
		// on every product for the rest of the visit; ?sk_preview_views=off clears it.
		var simulated = null;
		if (badge.dataset.previewInflate) {
			var param = new URLSearchParams(window.location.search).get('sk_preview_views');
			try {
				if (param === 'off') sessionStorage.removeItem('sk-preview-views');
				else if (param !== null && param !== '') sessionStorage.setItem('sk-preview-views', param);
				simulated = sessionStorage.getItem('sk-preview-views');
			} catch (error) {
				simulated = param;
			}
		}
		if (simulated !== null && simulated !== '' && Number.isFinite(Number(simulated))) count = Number(simulated);

		var minimum = Number(badge.dataset.minimumCount);
		if (badge.dataset.display !== 'on' || count === null || !(count >= minimum)) return;

		// Test-theme preview only: the owner's ads formula.
		if (badge.dataset.previewInflate === 'daily') {
			var date = new Date().toISOString().slice(0, 10);
			var dateNumber = 0;
			for (var i = 0; i < date.length; i++) dateNumber += date.charCodeAt(i);
			count = count * 10 + (dateNumber % 50);
		}

		var number = badge.querySelector('[data-product-view-count-number]');
		if (number) number.textContent = formatCount(count);

		var media = badge.closest('.product__media-list');
		if (media && window.getComputedStyle(media).position === 'static') {
			media.style.position = 'relative';
		}

		function update() {
			var first = media && media.querySelector('.product__media-item[data-hash="slide1"]');
			var active = media && media.querySelector('.product__media-item.swiper-slide-active');
			var visible = Boolean(first && (!active || active === first));
			badge.hidden = !visible;
			badge.style.display = visible ? 'flex' : 'none';
		}

		update();
		if (media) {
			new MutationObserver(update).observe(media, {
				subtree: true,
				childList: true,
				attributes: true,
				attributeFilter: ['class']
			});
		}
	}

	function init(badge) {
		if (badge.dataset.skViewCount) return;
		badge.dataset.skViewCount = 'ready';
		if (!badge.dataset.endpoint || !badge.dataset.productId) return;

		var showing = badge.dataset.display === 'on';
		var productId = badge.dataset.productId;
		var counted = false;

		function read() {
			if (showing) request(badge, 'GET').then(function (count) { show(badge, count); });
		}

		// Every consented view is a page view; only this browser's first view
		// of the product today is also a person. The mark is set before the
		// request, not after: the POST is sent with keepalive and lands even if
		// the shopper leaves first, and a mark set only on the response would
		// then be lost and the next visit counted as a new person.
		function count() {
			if (counted) return;
			counted = true;
			var newPerson = !countedToday(productId);
			if (newPerson) markCounted(productId);
			request(badge, 'POST', newPerson).then(function (total) {
				if (total === null && newPerson) unmarkCounted(productId);
				show(badge, total);
			});
		}

		whenShown(function () {
			// Test-theme preview only reads, so browsing it never adds views.
			if (isBot || badge.closest('quick-add-modal') || badge.dataset.previewInflate) return read();

			analyticsAllowed().then(function (allowed) {
				if (allowed) return count();
				read();
				// A shopper who accepts on the banner later in this visit is counted then.
				document.addEventListener('visitorConsentCollected', function (event) {
					if (event.detail && event.detail.analyticsAllowed) count();
				});
			});
		});
	}

	function initAll() {
		document.querySelectorAll('.product-view-count[data-product-id]').forEach(init);
	}

	function boot() {
		initAll();
		var pending;
		new MutationObserver(function () {
			clearTimeout(pending);
			pending = setTimeout(initAll, 100);
		}).observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
